<template>
    <div>
        <NuxtLayout>
            <template #body_page>
                <div class="page-how-it-works">
                    <SectionHero class="bg-hero pt-118 pb-118 mb-pt-95 mb-pb-95">
                        <template #title>
                            How It Works
                        </template>
                        <template #sub-title>
                            Extraordinary travel experiences are at your <br>
                            fingertips with Designer Journeys
                        </template>
                        <template #button>
                            <router-link
                                to="/trip-gallery"
                                class="button button-primary"
                                title="Go to page: Explore Our Gallery"
                                aria-label="Go to page: Explore Our Gallery"
                                @click="setGallerySource"
                            >
                                Explore Our Gallery
                            </router-link>
                        </template>
                    </SectionHero>
                    <SectionSteps/>
                    <SectionQuestion customClass="bg-cream-deep pt-100" :faqs = "faqs" :expandAll="expandAll">
                        <template #title>Still Have Questions?</template>
                        <template #sub-title>
                            Here we've answered the most commonly asked questions that travellers like you asked before designing their trip with Designer Journeys!
                        </template>
                    </SectionQuestion>
                    <SectionExplore heap-source="how-it-work-section-explore"/>
                </div>
            </template>
        </NuxtLayout>
    </div>
</template>

<script>
import { debounceAmplitudeScriptTracking } from '~/mixins/amplitude'
import SectionHero from '~/components/sections/SectionHero/SectionHero'
import SectionQuestion from '~/components/sections/SectionQuestion/SectionQuestion'
import SectionExplore from '~/components/pages/HowItWorks/sections/SectionExplore'
import SectionSteps from '~/components/pages/HowItWorks/sections/SectionSteps'
import { onMounted,/*computed,*/ ref } from 'vue'
import Metadata from '~/assets/meta_data.json'
import { useHeapStore } from '~/store/pinia/heap'

export default {
    name: 'HowItWorks',
    components: {
        SectionSteps,
        SectionQuestion,
        SectionExplore,
        SectionHero
    },
    setup() {
        // const route = useRoute()
        // const runtime = useRuntimeConfig()
        const expandAll = ref(true)
        const heapStore = useHeapStore()

        const faqs = ref([
            {
                id: 1,
                title: 'Why Should I Book My Trip with Designer Journeys?',
                text: 'We know that one of the most exciting parts of a trip is planning it. That’s why we connect you directly to the experts, our in-destination locals, who know their country better than anyone else. Simply let us know what you’re looking for, in however much detail you like, and we’ll work with you and our Local Designers to deliver your perfect trip. By choosing to design your trip with Designer Journeys, you remove the complexities of booking different elements of your trip with a myriad of providers and the result is an extraordinary travel experience!',
            },
            {
                id: 2,
                title: 'Who are Designer Journeys’ Local Designers? ',
                text: 'Designer Journeys’ global network of Local Designers are hand-selected, deeply knowledgeable local travel experts that deliver unique experiences and on-the-ground support for travellers. Our Local Designers are made up of in-destination inbound travel agents, tour operators, destination management teams and accommodation providers that build custom travel experiences and curated travel packages with their local knowledge and destination insight. All of Designer Journeys’ Local Designers complete an intensive selection process to ensure they are reliable, vetted, trustworthy and deliver quality travel experiences every time.',
            },
            {
                id: 3,
                title: 'How Do You Screen Your Local Designers?',
                text: 'To become a Designer Journeys Local Designer, applicants go through a rigorous selection process to ensure they are reliable, vetted, trustworthy and can deliver unique experiences. Only when they have passed this process, provided strong evidence of positive traveller feedback and necessary accreditations do they become a Local Designer.',
            },
            {
                id: 4,
                title: 'What Trips Can I Book With Designer Journeys?',
                text: 'With a gallery of almost 2,000 customisable trips across 75 countries worldwide, Designer Journeys is committed to designing, building, and delivering extraordinary travel experiences that are customised to you. Wherever you’re looking to travel, however you want to travel, whatever you’d like to do, whoever you’re travelling with, and for whatever reason; our team will work with you and our expert Local Designers to design your custom trip. By choosing Designer Journeys, you’ll open your world to exploring in extraordinary ways with unique activities and local experiences. Head to our trip gallery to begin your Designer Journey!',
            },
        ])
        const metaData = ref(Metadata);

        const setGallerySource = async () => {
            await heapStore.changeGalleryHeap("how-it-work-hero-section")
        }

        onMounted(() => {
          debounceAmplitudeScriptTracking("View How It Work")
        })
        // useHead({
        //     title: computed(() => {
        //         const title = metaData.value.how_it_works.title
        //         return title
        //     }),

        //     meta: computed(() => {
        //         const title = metaData.value.how_it_works.title
        //         const description = metaData.value.how_it_works.description
        //         return [
        //             {
        //                 name: `title`,
        //                 content: title,
        //             },
        //             {
        //                 name: `description`,
        //                 content: description,
        //             }
        //         ]
        //     }),
        //     link: computed(() => {
        //         return [
        //             { rel: 'canonical', href: `${runtime.public.publicDomain}${route.fullPath}`, hreflang: 'en'}
        //         ]
        //     }),
        // })

        onMounted(()=> expandAll.value = false)

        return {metaData, faqs, expandAll, setGallerySource}
    }

}
</script>
<style scoped lang='scss'>
.page-how-it-works {
    background-color: $background; // Wave 5A cream canvas (--dj-bg seam, W7-ready); hero photo covers its own region
}
.bg-hero {
    background: url('#{$assets-cdn}/images/howitworks/bg-banner.jpg');
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
}
</style>

